import { boldFont, dangerColor, labelColor } from "@app/styles";
import styled from "styled-components";


export const SuccessContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  svg {
    width: 150px;
    height: 150px;
    margin-bottom: 16px;
  }
  .failure{
    color: ${dangerColor};
  }
  &.p-0{
    padding: 0;
  }
`;

export const ProfileSuccessText = styled.p`
  font-style: normal;
  ${boldFont};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  // margin-bottom:1rem;
  margin-bottom: 10px;
  // color: ${labelColor};
  // margin: 0;
  @media (max-width: 575px){
    text-align: center;
  }
`;